import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
    providedIn: 'root'
})
export class ContextMenuService {
    private contextMenu = new BehaviorSubject<HTMLElement | null>(null);
    contextMenu$ = this.contextMenu.asObservable();

    public updateContextMenu(node: HTMLElement | null) {
        this.contextMenu.next(node);
    }

    public getContextMenu(): HTMLElement | null {
      return this.contextMenu.getValue();
    }
}